module.exports = __webpack_public_path__ + "static/img/anxun21new4.492243d8.png";